export const SET_TEAM_LOADING = "SET_TEAM_LOADING";
export const SET_TEAM_SUCCESS = "SET_TEAM_SUCCESS";
export const SET_TEAM_ERROR = "SET_TEAM_ERROR";
export const SET_INVITATION_LOADING = "SET_INVITATION_LOADING"
export const SET_INVITATION_SUCCESS = "SET_INVITATION_SUCCESS";
export const SET_INVITATION_ERROR = "SET_INVITATION_ERROR";
export const RESET_INVITATION = "RESET_INVITATION";
export const SET_REMOVE_INVITATION_LOADING = "team/revoke/loading"
export const SET_REMOVE_INVITATION_SUCCESS = "team/revoke/success"
export const SET_REMOVE_INVITATION_ERROR = "team/revoke/error"